import { testimonialList } from "@/mocks/site";

const stats = [
  { value: "1280+", label: "已发布合集期数" },
  { value: "36", label: "覆盖话题数量（百条）" },
  { value: "6", label: "常设内容分类" },
  { value: "1 个工作日", label: "内容纠错响应时效" },
];

export default function VoiceSection() {
  return (
    <section className="mt-16 rounded-card bg-background-100 px-5 py-12 md:mt-24 md:px-10 md:py-16">
      <div className="mx-auto max-w-[1280px]">
        <div className="mb-10 text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-chat-smile-2-line text-[11px]"></i>
            </span>
            用户口碑
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            吃瓜群众怎么说
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
            我们收集了部分读者的真实反馈，内容会定期更新，也会保留批评意见。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {testimonialList.map((item) => (
            <blockquote
              key={item.name}
              className="flex flex-col rounded-card border border-background-200/80 bg-background-50 p-6"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-double-quotes-l text-base"></i>
              </span>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.content}
              </p>
              <footer className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 text-sm font-bold text-background-50">
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <cite className="text-sm font-medium not-italic text-foreground-900">
                    {item.name}
                  </cite>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </footer>
            </blockquote>
          ))}
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-6 border-t border-background-300/60 pt-10 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label}>
              <dt className="text-xs text-foreground-500">{stat.label}</dt>
              <dd className="mt-2 font-heading text-2xl font-black text-primary-600">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}